import React from 'react';
import { ZORLUK_FILTRE_SECENEKLERI } from '../lib/zorlukSeviye';

// Soru listesi süzgeçleri + sayfalama — YKS paneli ve lgs.* listesi AYNI bileşeni kullanır
// (2026-10-20, kullanıcı isteği "YKS filtrelerinin benzerleri LGS'de"). Değerler App.js
// state'inde durur; backend parametre adları routes/sorular.js GET / ile birebir.

// Süzgeç açılır kutusu: varsayılanda sade, seçiliyken kendi renginde yanar
// (pratik amber, bağlam indigo... kart rozetleriyle eşleşir).
export const suzgecSinifi = (aktif, renk) => `px-2 py-1.5 rounded border text-xs ${aktif ? renk : 'border-gray-300 bg-white text-gray-700'}`;

// SIRALAMA (öğretmen kararı 2026-08-28) — durum süzgecinin yerine geçti. `son işlem` =
// GREATEST(olusturulma, guncelleme, onay); gerekçe routes/sorular.js ORDER BY notunda.
export const SIRALAMALAR = [
  { value: 'islem', label: '🕒 Son işlem: yeni' },
  { value: 'islem_eski', label: '🕒 Son işlem: eski' },
  { value: 'tarih', label: '🆕 Üretim: yeni' },
];

// Gruplar arasında ayraç çizilir: değerlendirme | içerik.
const SUZGECLER = [
  [
    // Bantlar lib/zorlukSeviye.js'ten — rozet renkleriyle AYNI kaynak.
    { ad: 'puan', aria: 'Puan filtresi', title: 'Puan', renk: 'border-blue-400 bg-blue-50 text-blue-800 font-semibold',
      secenekler: [['', 'Puan: tümü'], ['yok', 'Puan yok'], ...ZORLUK_FILTRE_SECENEKLERI.map((o) => [o.value, o.label])] },
    // CEVAP QC (2026-09-15): kör denetçinin ya da öğretmenin kör onayının anahtarla uyuşmadığı sorular.
    { ad: 'qc', aria: 'Cevap QC durumu', title: 'Cevap QC: anahtarı görmeden yeniden çözüm + kör onay', renk: 'border-violet-400 bg-violet-50 text-violet-800 font-semibold',
      secenekler: [['', 'QC: tümü'], ['uyusmazlik', '⚠ QC uyuşmazlık'], ['onayli', '✓ QC onaylı'], ['yok', 'QC denetlenmedi']] },
    // ZORLUK KÖR ÖRNEKLEMİ (2026-09-25): öğretmen ajan puanını görmeden puanlar.
    { ad: 'kor', aria: 'Kör puan örneklemi', title: 'Kör puan: ajanın puanladığı sorular, ajan puanı gizli (ölçüm)', renk: 'border-orange-400 bg-orange-50 text-orange-800 font-semibold',
      secenekler: [['', '🙈 Kör puan: tümü'], ['bekliyor', '🙈 Kör puan bekleyen'], ['verildi', '✓ Kör puan verilen']] },
  ],
  [
    { ad: 'gorsel', aria: 'Görsel filtresi', title: 'Görsel: TikZ ya da SVG figürlü sorular', renk: 'border-teal-400 bg-teal-50 text-teal-800 font-semibold',
      secenekler: [['', '🖼 Görsel: tümü'], ['var', '🖼 Görselli'], ['tikz', 'TikZ'], ['svg', 'SVG'], ['yok', '○ Görselsiz']] },
    // BAĞLAM (öğretmen 2026-08-13): rozetle aynı koşul, `kaynak_detay.baglam_grubu`.
    { ad: 'baglam', aria: 'Bağlam temelli soru filtresi', title: 'Bağlam temelli soru (ortak kök altında birden çok bağımsız soru)', renk: 'border-indigo-400 bg-indigo-50 text-indigo-800 font-semibold',
      secenekler: [['', '🔗 Bağlam: tümü'], ['var', '🔗 Bağlam temelli'], ['yok', '○ Tekil soru']] },
    // KOMŞU (2026-10-19): disiplinler arası bağlamla üretilen sorular (soru kartı baglam.tur).
    { ad: 'komsu', aria: 'Komşu: disiplinler arası sorular', title: 'Komşu: disiplinler arası bağlamla üretilen sorular', renk: 'border-cyan-400 bg-cyan-50 text-cyan-800 font-semibold',
      secenekler: [['', '🧭 Komşu: tümü'], ['var', '🧭 Komşu'], ['yok', '○ Komşusuz']] },
    { ad: 'pratik', aria: 'Pratik çözüm durumu', title: 'Pratik çözüm durumu', renk: 'border-amber-400 bg-amber-50 text-amber-800 font-semibold',
      secenekler: [['', '⚡ Pratik: tümü'], ['var', '⚡ Pratikli'], ['yok', '○ Pratiksiz'], ['onayli', '✓ Pratik onaylı'], ['bekliyor', '⌛ Öğretmen bakmadı'], ['red', '✗ Pratik reddedildi']] },
  ],
];

const Ayrac = () => <span className="mx-0.5 hidden h-5 w-px bg-gray-200 sm:block" aria-hidden="true" />;

/** degerler: { puan, qc, kor, gorsel, baglam, komsu, pratik }; onDegis(ad, deger).
 *  sinif(aktif) verilirse kutular tek tip boyanır (LGS "optik form"); yoksa YKS'nin süzgeç renkleri. */
export function SuzgecSecimleri({ degerler, onDegis, sinif = null }) {
  return SUZGECLER.map((grup, gi) => (
    <React.Fragment key={gi}>
      {gi > 0 && <Ayrac />}
      {grup.map((s) => (
        <select key={s.ad} aria-label={s.aria} title={s.title} value={degerler[s.ad] || ''}
          onChange={(e) => onDegis(s.ad, e.target.value)} className={sinif ? sinif(degerler[s.ad]) : suzgecSinifi(degerler[s.ad], s.renk)}>
          {s.secenekler.map(([v, l]) => <option key={v} value={v}>{l}</option>)}
        </select>
      ))}
    </React.Fragment>
  ));
}

// Sayfalama numara penceresi: her zaman ilk + son sayfa, aktif sayfanın iki yanı,
// aradaki boşluklar '...' ile. Örn. aktif=6, toplam=20 → [1, '...', 4,5,6,7,8, '...', 20]
export function sayfaNumaralari(aktif, toplam, komsu = 2) {
  const bas = Math.max(1, aktif - komsu);
  const son = Math.min(toplam, aktif + komsu);
  const liste = [];
  if (bas > 1) {
    liste.push(1);
    if (bas > 2) liste.push('...');
  }
  for (let i = bas; i <= son; i++) liste.push(i);
  if (son < toplam) {
    if (son < toplam - 1) liste.push('...');
    liste.push(toplam);
  }
  return liste;
}

// Tailwind sınıfları derleme anında taranır — renk tam sınıf adlarıyla seçilir.
const RENK = {
  blue: { kenar: 'border-blue-600 text-blue-600', aktif: 'bg-blue-600 text-white font-semibold border border-blue-600', hover: 'hover:border-blue-600 hover:text-blue-600' },
  pink: { kenar: 'border-pink-600 text-pink-700', aktif: 'bg-pink-600 text-white font-semibold border border-pink-600', hover: 'hover:border-pink-600 hover:text-pink-700' },
  optik: { kenar: 'border-lgs-cizgi text-lgs-murekkep bg-white', aktif: 'bg-lgs-murekkep text-white font-medium border border-lgs-murekkep', hover: 'hover:border-lgs-murekkep' },
};

/** Numaralı sayfalama (tek tık ile herhangi bir sayfaya). */
export function Sayfalama({ sayfa, toplamSayfa, sayfaGit, renk = 'blue' }) {
  if (toplamSayfa <= 1) return null;
  const r = RENK[renk] || RENK.blue;
  const ok = `rounded-lg border ${r.kenar} disabled:opacity-40 disabled:cursor-not-allowed`;
  return (
    <nav aria-label="Sayfalama" className="flex flex-wrap justify-center items-center gap-1.5 mt-6">
      <button title="İlk sayfa" aria-label="İlk sayfa" disabled={sayfa <= 1} onClick={() => sayfaGit(1)} className={`px-2.5 py-2 ${ok}`}>«</button>
      <button disabled={sayfa <= 1} onClick={() => sayfaGit(sayfa - 1)} className={`px-3 py-2 ${ok}`}>‹ Önceki</button>
      {sayfaNumaralari(sayfa, toplamSayfa).map((n, i) => (
        n === '...'
          ? <span key={`bosluk-${i}`} className="px-1 text-gray-400 select-none">…</span>
          : <button key={n} onClick={() => sayfaGit(n)} aria-current={n === sayfa ? 'page' : undefined}
              className={`min-w-[2.25rem] px-3 py-2 rounded-lg text-sm ${n === sayfa ? r.aktif : `border border-gray-300 text-gray-700 ${r.hover}`}`}>{n}</button>
      ))}
      <button disabled={sayfa >= toplamSayfa} onClick={() => sayfaGit(sayfa + 1)} className={`px-3 py-2 ${ok}`}>Sonraki ›</button>
      <button title="Son sayfa" aria-label="Son sayfa" disabled={sayfa >= toplamSayfa} onClick={() => sayfaGit(toplamSayfa)} className={`px-2.5 py-2 ${ok}`}>»</button>
      {toplamSayfa > 7 && (
        <span className="ml-3 flex items-center gap-1.5 text-xs text-gray-500">
          Sayfaya git:
          <input key={sayfa} type="number" min={1} max={toplamSayfa} defaultValue={sayfa}
            title="Sayfa numarası yaz, Enter'a bas"
            onKeyDown={(e) => { if (e.key === 'Enter') sayfaGit(e.target.value); }}
            className="w-16 px-2 py-1 rounded border border-gray-300 text-xs" />
          / {toplamSayfa}
        </span>
      )}
    </nav>
  );
}
